module.exports = __webpack_public_path__ + "img/symbol_5.2a992af2.png";